import React from "react";
import { useState } from "@vrf/fr-vrf-core-react";
import { AppContext, AppInitialState } from "./";

export const AppStateProvider = ({ children }: any) => {
  const [appState, setAppState] = useState(AppInitialState);
  const context = {
    appState: appState,
    setAppState: setAppState,
  };
  return <AppContext.Provider value={context}>{children}</AppContext.Provider>;
};
